import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/registered',
      component: () => import(/* webpackChunkName: "about" */ '@/views/registration/Success')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/auth/signin',
      component: () => import(/* webpackChunkName: "auth" */'@/views/auth/Signin'),
    },
    {
      path: '/auth/signup',
      component: () => import(/* webpackChunkName: "auth" */'@/views/auth/Signup')
    },
    {
      path: '/auth/confirm',
      component: () => import(/* webpackChunkName: "auth" */'@/views/auth/Confirm')
    },
    {
      path: '/auth/forgotpassword',
      component: () => import(/* webpackChunkName: "auth" */'@/views/auth/ForgotPassword'),
    },
    {
      path: '/auth/entercode',
      component: () => import(/* webpackChunkName: "auth" */'@/views/auth/EnterCodeReset')
    },
    {
      path: '/auth/resetpassword',
      component: () => import(/* webpackChunkName: "auth" */'@/views/auth/ResetPassword')
    },
    {
      path: '/auth/inviteconfirm',
      component: () => import(/* webpackChunkName: "auth" */'@/views/auth/InviteConfirm')
    },
    {
      path: '/authenticated',
      component: () => import (/* webpackChunkName: "authenticated"*/ '@/views/Authenticated')
    },
    {
      path: '/createevent',
      component: () => import (/* webpackChunkName: "authenticated"*/ '@/views/event/Create')
    },
    {
      path: '/createevent',
      component: () => import (/* webpackChunkName: "authenticated"*/ '@/views/event/Create')
    },
    {
      path: '/paymentmethods',
      component: () => import (/* webpackChunkName: "authenticated"*/ '@/views/customers/Payment')
    },
    {
      path:'/faqs',
      component: () => import (/* webpackChunkName: "openauth"*/ '@/views/faqs/Index')
    },
    {
      path:"/registeredteams",
      component: () => import (/* webpackChunkName: "openauth"*/ '@/views/registration/Teams')
    },
    {
      path:"/myregistration",
      component: () => import (/* webpackChunkName: "registration"*/ '@/views/registration/MyRegistration')
    },
    {
      path:"/forms",
      component: () => import (/* webpackChunkName: "openauth"*/ '@/views/forms/forms')
    }
  ]
})
